import type { SessionStepModule } from '../types';
import { FaceDetail } from './FaceDetail';
import { FaceStepRunner } from './FaceStepRunner';
import { isFaceStep } from './face.utils';

// Face Match step module (SEBI spec §6 — Provider A Active / Provider B Passive).
export const faceStepModule: SessionStepModule = {
  key: 'face',
  matches: isFaceStep,
  Runner: FaceStepRunner,
  Detail: FaceDetail,
};
